import { observer } from 'mobx-react';
import { exportJsonToCSV } from '../../../../../Utils/CSV';
import { FailedParticipant, SuccessfulParticipant } from '../../Store/Types';
import { T } from '../../../../../Translations';

interface Props {
  downloadData: Array<SuccessfulParticipant | FailedParticipant>;
}

function DownloadCSV({ downloadData }: Props) {
  return (
    <a
      href="#"
      onClick={() => exportJsonToCSV(downloadData, 'import_participants.csv')}
      className="cursor-pointer text-teal-600"
    >
      <T kind="Download full CSV" />
    </a>
  );
}

export default observer(DownloadCSV);
